export async function getPrescribersByTerritory(marketId, territoryId, productId) {
	if (!marketId || !territoryId) {
		throw new Error('Missing required parameters');
	}

	const productParam = productId ? `?productId=${encodeURIComponent(productId)}` : '';
	const url = `${process.env.REACT_APP_API_URL}PrescribersByTerritory/${encodeURIComponent(marketId)}/${encodeURIComponent(territoryId)}${productParam}`;
	const response = await fetch(url, {
		method: 'GET',
		credentials: 'include',
		headers: {
			'Content-Type': 'application/json',
		},
	});

	if (response.status === 200) {
		return await response.json();
	} else {
		throw response.statusText;
	}
}

export async function getPrescribers(filter, favoriteOnly) {
	const url = `${process.env.REACT_APP_API_URL}Prescribers?favoriteOnly=${favoriteOnly}&filter=${encodeURIComponent(filter)}`;
	const response = await fetch(url, {
		method: 'GET',
		credentials: 'include',
	});

	if (response.status === 200) {
		return await response.json();
	} else {
		throw response.statusText;
	}
}

export async function getPrescriberById(id, marketId, territoryId) {
	if (!marketId || !territoryId) {
		throw new Error('Missing required parameters');
	}

	const url = `${process.env.REACT_APP_API_URL}Prescriber/${encodeURIComponent(id)}?marketId=${encodeURIComponent(marketId)}&territoryId=${encodeURIComponent(territoryId)}`;
	const response = await fetch(url, {
		method: 'GET',
		credentials: 'include',
	});

	if (response.status === 200) {
		const data = await response.json();
		return {...data.prescriber, favorite: data.favorite};
	} else {
		throw response.statusText;
	}
}

export async function updateFavoriteHcp(hcpId, remove) {
	if (!hcpId) {
		throw new Error('Missing required parameters');
	}
	const url = `${process.env.REACT_APP_API_URL}User/FavoriteHcp`;

	const response = await fetch(url, {
		method: 'POST',
		credentials: 'include',
		headers: {
			'Content-Type': 'application/json',
		},
		body: JSON.stringify({ hcpId, remove }),
	});
	if (response.status === 200) {
		return true;
	} else {
		throw response.statusText;
	}
}